import {
    HttpErrorInfo,
    HttpErrorInterface
} from "../../../realms/types/httpError.interface"
import { HotmartRum } from "@commons/observability"
import { ErrorBase } from "./errorBase"

export class RequestError extends ErrorBase {
    constructor(errorData: HttpErrorInterface) {
        super(errorData.error.message)
        this.name = "RequestError"

        this.clearStacktrace()
        this.captureError({
            method: errorData.method,
            url: errorData.url,
            body: errorData.body
        })
    }

    private captureError(httpErrorInfo: HttpErrorInfo) {
        HotmartRum.captureException(this, {
            extra: { httpErrorInfo }
        })
    }
}
